<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isPurchaseManager()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Request Details | Purchase Manager</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-outline collapsed-card card-danger">
                        <div class="card-header">
                            <div class="card-title">
                                <h5>Data Filters</h5>
                            </div>
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button
                                    type="button"
                                    class="btn btn-tool"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body overflow-auto">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Branch:</span
                                            >
                                            <v-select
                                                v-model="branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branches"
                                                :reduce="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Job No.:</span
                                            >
                                            <input
                                                type="text"
                                                v-model="job_no"
                                                placeholder="Enter job no."
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >From Date:</span
                                            >
                                            <input
                                                type="date"
                                                v-model="from"
                                                placeholder="Select from date"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >To Date:</span
                                            >
                                            <input
                                                type="date"
                                                v-model="to"
                                                placeholder="Select to date"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100%"
                                            @click="
                                                getRequests('/api/getRequests')
                                            "
                                        >
                                            <i class="fa fa-search"></i> Search
                                        </button>
                                    </div>
                                    <div class="col-sm-4">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100%"
                                            @click="reset"
                                        >
                                            <i class="fa fa-times"></i> Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-danger card-outline">
                        <div class="card-header">Parts Requests</div>
                        <div class="card-body overflow-auto">
                            <img v-if="requests == ''" src="" />
                            <datatable
                                style="margin-top: 1%"
                                :columns="columns"
                                v-else
                            >
                                <tbody>
                                    <tr v-for="b in requests" :key="b.id">
                                        <td>
                                            <a
                                                :href="
                                                    '/purchase-manager/job-profile/' +
                                                    b.job_id
                                                "
                                                >{{ b.job_no }}</a
                                            >
                                        </td>
                                        <td>{{ b.part }}</td>
                                        <td>{{ b.urgency }}</td>
                                        <td>{{ b.item_name }}</td>
                                        <td>{{ b.from_branch }}</td>
                                        <td>{{ b.created_at | issueDate }}</td>
                                        <td>
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <button
                                                            class="btn btn-danger"
                                                            style="width: 100%"
                                                            @click="view(b.id)"
                                                        >
                                                            <i
                                                                class="fa fa-eye"
                                                            ></i>
                                                            View More
                                                        </button>
                                                    </div>
                                                    <br />
                                                    <br />
                                                    <div class="col-md-12">
                                                        <button
                                                            class="btn btn-primary"
                                                            style="width: 100%"
                                                            @click="poModal(b)"
                                                        >
                                                            <i
                                                                class="fa fa-edit"
                                                            ></i>
                                                            Purchase Order
                                                        </button>
                                                    </div>
                                                    <br />
                                                    <br />
                                                    <div class="col-md-12">
                                                        <button
                                                            class="btn btn-danger"
                                                            style="width: 100%"
                                                            @click="
                                                                declineModal(b)
                                                            "
                                                        >
                                                            <i
                                                                class="fa fa-times"
                                                            ></i>
                                                            Decline
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </datatable>
                        </div>
                        <div class="card-footer">
                            <pagination
                                :pagination="pagination"
                                @prev="getRequests(pagination.prevPageUrl)"
                                @next="getRequests(pagination.nextPageUrl)"
                            ></pagination>
                        </div>
                    </div>
                </div>

                <div class="modal" tabindex="-1" role="dialog" id="poModal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">
                                    Generate Purchase Order
                                </h5>
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.item_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Item Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the item name"
                                        v-model="form.item_name"
                                    />
                                    <span
                                        v-if="errors.item_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid item name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.part_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Part Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the part name"
                                        v-model="form.part_name"
                                    />
                                    <span
                                        v-if="errors.part_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid part name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.vendor_id ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Vendor</label>
                                    <v-select
                                        type="text"
                                        class="form-control"
                                        placeholder="Please choose a vendor"
                                        v-model="form.vendor_id"
                                        :options="vendors"
                                        label="name"
                                        :reduce="(vendors) => vendors.id"
                                        @input="fillVendor"
                                    ></v-select>
                                    <span
                                        v-if="errors.vendor_id"
                                        :class="['badge bg-danger']"
                                        >Please choose a valid vendor.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.vendor_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Vendor Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the vendor name"
                                        v-model="form.vendor_name"
                                    />
                                    <span
                                        v-if="errors.vendor_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid vendor name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.vendor_address
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Vendor Address</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the vendor address"
                                        v-model="form.vendor_address"
                                    />
                                    <span
                                        v-if="errors.vendor_address"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid vendor
                                        address.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.vendor_phone ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Vendor Phone</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the vendor phone"
                                        v-model="form.vendor_phone"
                                    />
                                    <span
                                        v-if="errors.vendor_phone"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid vendor
                                        phone.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.vendor_gst ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Vendor GST</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the vendor GST"
                                        v-model="form.vendor_gst"
                                    />
                                    <span
                                        v-if="errors.vendor_gst"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid vendor GST.</span
                                    >
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        @click="generatePO"
                                    >
                                        Generate
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="modal"
                    tabindex="-1"
                    role="dialog"
                    id="declineModal"
                >
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Decline Order</h5>
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <h3>
                                    Are you sure you want to decline the
                                    request?
                                </h3>
                            </div>
                            <div class="modal-footer">
                                <button
                                    class="btn btn-success"
                                    @click="decline"
                                    data-dismiss="modal"
                                >
                                    Yes
                                </button>
                                <button
                                    class="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isPurchaseManager()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getRequests();
        this.getVendors();
        this.getBranches();
    },

    components: { datatable: Datatable, pagination: Pagination },

    data() {
        let columns = [
            { width: "10%", label: "Job No", name: "job_no" },
            { width: "20%", label: "Requirement", name: "part" },
            { width: "10%", label: "Urgency", name: "urgency" },
            { width: "20%", label: "Item Name", name: "item_name" },
            { width: "10%", label: "Branch", name: "branch" },
            { width: "10%", label: "Date", name: "date" },
            { width: "20%", label: "View More", name: "ops" },
        ];

        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            requests: [],
            vendors: [],
            form: new Form({
                item_name: "",
                part_name: "",
                part_description: "",
                vendor_id: "",
                vendor_name: "",
                vendor_address: "",
                vendor_phone: "",
                vendor_gst: "",
                request: "",
            }),
            errors: [],
            branches: [],
            decline_id: "",
            branch: "",
            job_no: "",
            from: "",
            to: "",
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getVendors() {
            axios.post("/api/getAllVendors").then((response) => {
                this.vendors = response.data;
            });
        },

        poModal(item) {
            if (item.po == null) {
                this.form.item_name = item.item_name;
                this.form.part_name = item.part;
                this.form.request = item.id;
                $("#poModal").modal("show");
            } else
                this.$router.push(
                    "/purchase-manager/purchase-order/" + item.po
                );
        },

        fillVendor() {
            var vendor = this.vendors.find((c) => c.id == this.form.vendor_id);
            this.form.vendor_name = vendor.name;
            this.form.vendor_address = vendor.address;
            this.form.vendor_phone = vendor.phone;
            this.form.vendor_gst = vendor.gst;
        },

        generatePO() {
            this.form
                .post("/api/generatePO")
                .then((response) => {
                    toast.fire({
                        icon: "success",
                        title: "Purchase Order Generated",
                    });
                    $("#poModal").modal("hide");
                    this.$router.push(
                        "/purchase-manager/purchase-order/" + response.data.id
                    );
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getRequests(url = "/api/getRequests") {
            axios
                .post(url, {
                    branch: this.branch,
                    job_no: this.job_no,
                    from: this.from,
                    to: this.to,
                })
                .then((response) => {
                    this.requests = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        view(id) {
            this.$router.push("/purchase-manager/request-data/" + id);
        },

        declineModal(req) {
            this.decline_id = req.id;
            $("#declineModal").modal("show");
        },

        decline() {
            axios
                .post("/api/declineRequest", { request: this.decline_id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Request Declined",
                        });
                        this.getRequests();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        reset() {
            this.branch = "";
            this.job_no = "";
            this.from = "";
            this.to = "";
            this.getRequests();
        },
    },
};
</script>
